module.exports = {
  title: '订单对账单-汇总详情',
  route: {
    path: '/finance-manage',
    children: {
      path: 'account-statement-summary-detail',
    },
  },
};
